var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "feedback" },
    [
      _c("pageTitle", _vm._b({}, "pageTitle", { ..._vm.pT }, false)),
      _c("business-group", {
        ref: "businessGroup",
        attrs: {
          tableConfig: { ..._vm.tableConfig },
          formConfig: { ..._vm.formConfig },
        },
        scopedSlots: _vm._u([
          {
            key: "pictures",
            fn: function (record) {
              return [_c("m-image", { attrs: { url: record.pictures } })]
            },
          },
          {
            key: "nickname",
            fn: function (record) {
              return [
                _c(
                  "div",
                  { staticClass: "feedback-nickname" },
                  [
                    record.avatar
                      ? _c("m-image", {
                          attrs: { size: 40, url: record.avatar },
                        })
                      : _vm._e(),
                    _c("span", [_vm._v(_vm._s(record.nickname))]),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }